import { createAsyncThunk } from "@reduxjs/toolkit"
import { post, get, patch, del, put } from "helpers/api_helper"
import {
  ADD_ISSUE_TYPE,
  DELETE_ISSUE_TYPE,
  GET_ALL_ISSUE_TYPE,
  GET_ALL_SUPPORT_TICKET,
  GET_ISSUE_TYPE_DETAILS,
  GET_TICKET_DETAILS,
  ISSUE_TYPE_DROPDOWN_LISTS,
  UPDATE_BULK_TICKET_STATUS,
  UPDATE_ISSUE_TYPE_DETAILS,
  UPDATE_ISSUE_TYPE_STATUS,
  UPDATE_TICKET_STATUS,
} from "helpers/url_helper"

export const getAllIssueType = createAsyncThunk(
  GET_ALL_ISSUE_TYPE,
  async payload => {
    const response = await post(GET_ALL_ISSUE_TYPE, payload)
    return response
  }
)

export const updateIssueTypeStatus = createAsyncThunk(
  UPDATE_ISSUE_TYPE_STATUS,
  async payload => {
    const response = await patch(UPDATE_ISSUE_TYPE_STATUS, payload)
    return response
  }
)

export const deleteIssueType = createAsyncThunk(
  DELETE_ISSUE_TYPE,
  async payload => {
    const response = await del(DELETE_ISSUE_TYPE, payload)
    return response
  }
)

export const addIssueType = createAsyncThunk(ADD_ISSUE_TYPE, async payload => {
  const response = await post(ADD_ISSUE_TYPE, payload)
  return response
})

export const getIssueTypeDetails = createAsyncThunk(
  GET_ISSUE_TYPE_DETAILS,
  async payload => {
    const response = await post(GET_ISSUE_TYPE_DETAILS, payload)
    return response
  }
)

export const updateIssueTypeDetails = createAsyncThunk(
  UPDATE_ISSUE_TYPE_DETAILS,
  async payload => {
    const response = await put(UPDATE_ISSUE_TYPE_DETAILS, payload)
    return response
  }
)

export const getIssueTypeDropdownLists = createAsyncThunk(
  ISSUE_TYPE_DROPDOWN_LISTS,
  async payload => {
    const response = await get(ISSUE_TYPE_DROPDOWN_LISTS, payload)
    return response
  }
)

//  SUPPORT TICKET
export const getAllSupportTicket = createAsyncThunk(
  GET_ALL_SUPPORT_TICKET,
  async payload => {
    const response = await post(GET_ALL_SUPPORT_TICKET, payload)
    return response
  }
)

export const getTicketDetails = createAsyncThunk(
  GET_TICKET_DETAILS,
  async payload => {
    const response = await post(GET_TICKET_DETAILS, payload)
    return response
  }
)

export const updateTicketStatus = createAsyncThunk(
  UPDATE_TICKET_STATUS,
  async payload => {
    const response = await patch(UPDATE_TICKET_STATUS, payload)
    return response
  }
)

export const updateBulkTickets = createAsyncThunk(
  UPDATE_BULK_TICKET_STATUS,
  async payload => {
    const response = await put(UPDATE_BULK_TICKET_STATUS, payload)
    return response
  }
)
